/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — PlatformDataGrid meta builder.
 * Shared mismatch/source/sync language for all commerce desks.
 */
import type { DataGridMeta } from '../components/platform/PlatformDataGrid';
import type { BuildGridMetaInput, CommerceGridMetaOptions } from './types';

export function buildCommerceGridMeta(
  page: BuildGridMetaInput | null | undefined,
  opts: CommerceGridMetaOptions,
): DataGridMeta | null {
  if (!page) return null;
  const returned = page.returned_count ?? page.count;
  const entity = opts.entityLabel ?? 'rows';
  const mismatch =
    opts.includeMismatchReason &&
    page.total_count != null &&
    returned != null &&
    page.total_count !== returned
      ? page.mismatch_reason ||
        `Database has ${page.total_count} ${entity}. Displayed ${returned} (page_size=${page.page_size}). Remaining: ${page.remaining}.`
      : page.mismatch_reason;

  return {
    total_count: page.total_count,
    returned_count: returned,
    page: page.page,
    page_size: page.page_size,
    pages: page.pages,
    remaining: page.remaining,
    has_more: page.has_more,
    execution_time_ms: page.execution_time_ms ?? opts.latencyMs,
    mismatch_reason: mismatch,
    source: page.source,
    data_source_badge: page.source || opts.dataSourceBadge,
    last_sync: opts.lastSync ?? undefined,
    amazon_count: opts.amazonCount ?? undefined,
  };
}
